import { render, staticRenderFns } from "./AboutYourPet.vue?vue&type=template&id=3c09dbd6&"
import script from "./AboutYourPet.vue?vue&type=script&lang=js&"
export * from "./AboutYourPet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports